<template>
    <section class="bg-light" id="informatique">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase titles">L'informatique</h2>
            <h3 class="section-subheading text-muted">Découvrons de manière complète ce qu'est l'informatique.</h3>          
			<p>
			L'informatique est un domaine d'activité scientifique, technique et industriel concernant le traitement automatique de l'information par l'exécution des programmes informatiques par des machines : des systèmes embarqués, des ordinateurs, des robots, des automates, etc.
			Ces champs d'application peuvent être séparés en deux branche : l'une de nature théorique, qui concerne la définition de concepts et modèles, et l'autre, de nature pratique, qui s'intéresse aux techniques concrètes de mise en oeuvre. Certains domaines de l'informatique peuvent être très 
			abstraits, comme la complexité algorithmique, et d'autres peuvent être plus proche d'un public profane. Ainsi la théorie des langages demeure un domaine davantage accessible aux professionnels formé : description des ordinateurs et des méthodes de programmation, tandis que les métiers liés 
			aux interfaces homme-machine sont accessibls à un plus large public.
			</p>
		  </div>
        </div>
		
        <div class="row">
			 <h2 class="section-heading text-uppercase">Technologies de l'informations et de la communication</h2>
            <div class="col-md-4 col-sm-6 portfolio-item" v-for="(obj, key) in informatiqueJSON" :key="key">
				<div class="portfolio-hover">
                    <div class="portfolio-hover-content">
                        <i class="fas fa-plus fa-3x"></i>
                    </div>
                </div>
				
					<img class="img-fluid img-inf" :src="obj.img" alt="">
               
                <div class="portfolio-caption">
                    <h4>{{ obj.caption }}</h4>                 
                </div>
            </div>			
        </div>
      </div>  	  
    </section>	
</template>

<script>
export default {
    data: () => ({
        informatiqueJSON: [
            {
                img: 'img/appareil_informatique.jpg',
                caption: 'Appareils informatique'
            },
            {
                img: 'img/materiel_informatique.jpg',
                caption: 'Matériel informatique'
            },
            {
                img: 'img/logiciels.jpg',
                caption: 'Logiciels'
            }
        ]
    })
}
</script>

<style lang="css">

</style>


